import Config from '@/config';
import {
  ClarificationListResult,
} from '@/types/api/clarifications';
import http, { HttpPromise } from './http';

const list = (role: string, params?: ClarificationListResult): HttpPromise<ClarificationListResult> => http.get<ClarificationListResult>(`${Config.apiHost}/${role}/clarification/list/`, { params });

export default {
  supplier: {
    list: list.bind(this, 'supplier'),
  },
  customer: {
    list: list.bind(this, 'customer'),
  },
};
